import { Component, computed, Input, ViewChild, signal } from '@angular/core';
import { CombinedOrderItem } from 'src/app/fleet/orders/types';
import { IonicModule, IonPopover } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DateChipComponent } from 'src/app/fleet/components/date-chip/date-chip.component';
import { CombinedOrdersContextService } from 'src/app/fleet/orders/services/combined-order.service';
import { Router, RouterModule } from '@angular/router';
import { FileUploadService } from 'src/app/fleet/orders/services/file-upload.service';
import { ORDER_STATUS_CLASSES } from 'src/app/fleet/orders/constants';
import {
  DELIVERY_STATUS_CLASSES,
  DELIVERY_STATUS_TRANSLATIONS,
  ORDER_STATUS_TRANSLATIONS,
} from 'src/app/fleet/orders/constants';

@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    TranslateModule,
    CommonModule,
    DateChipComponent,
    RouterModule,
  ],
})
export class OrderItemComponent {
  private _orderItem = signal<CombinedOrderItem>(null!);

  @Input({ required: true }) set orderItem(value: CombinedOrderItem) {
    this._orderItem.set(value);
  }

  get orderItem(): CombinedOrderItem {
    return this._orderItem();
  }

  protected startDate = computed(() => this._orderItem()?.order?.startDate);
  protected endDate = computed(() => this._orderItem()?.order?.endDate);

  files = computed(() => {
    return this.combinedOrderService.getOrderFiles(this._orderItem().id);
  });

  @ViewChild('popover') popover!: IonPopover;

  constructor(
    private combinedOrderService: CombinedOrdersContextService,
    private fileUploadService: FileUploadService,
    private router: Router,
  ) {}

  getStatusClass(status: string): string {
    return ORDER_STATUS_CLASSES[status] || '';
  }

  getDeliveryStatusClass(status: string): string {
    return DELIVERY_STATUS_CLASSES[status] || '';
  }

  getStatusTranslate(status: string): string {
    return ORDER_STATUS_TRANSLATIONS[status] || '';
  }

  getDeliveryStatusTranslate(status: string): string {
    return DELIVERY_STATUS_TRANSLATIONS[status] || '';
  }

  removeOrder() {
    this.combinedOrderService.remove(this._orderItem().id);
    this.dismissOptions();

    if (this.combinedOrderService.orders().length === 0) {
      this.router.navigate(['/fleet/orders']);
    }
  }

  copyOrder() {
    this.combinedOrderService.copy(this._orderItem());
    this.dismissOptions();
  }

  dismissOptions() {
    this.popover.dismiss();
  }

  hasUploadErrors() {
    return (
      !this.fileUploadService.allFilesUploaded() && this.files().length > 0
    );
  }

  getCity(field: 'origins' | 'destinations') {
    if (this._orderItem().order[field].length > 0) {
      return this._orderItem().order[field][0].city;
    }

    return '';
  }
}
